module.exports = __webpack_public_path__ + "static/media/villa-azul-4.ef59c21c.webp";